import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Menu as _Menu } from '@mui/material';
import { interopRequireDefault } from "./util/interopRequireDefault.mjs";
// work around https://github.com/vercel/next.js/issues/57285
const Menu = interopRequireDefault(_Menu);
const HoverMenu = /*#__PURE__*/React.forwardRef(function HoverMenu(props, ref) {
  var _props$PaperProps;
  return /*#__PURE__*/React.createElement(Menu, _extends({}, props, {
    ref: ref,
    style: {
      pointerEvents: 'none',
      ...props.style
    },
    PaperProps: {
      ...props.PaperProps,
      style: {
        pointerEvents: 'auto',
        ...((_props$PaperProps = props.PaperProps) === null || _props$PaperProps === void 0 ? void 0 : _props$PaperProps.style)
      }
    }
  }));
});
export default HoverMenu;